import BaseModel from '../core/BaseModel'
export default class ObjBoxModel extends BaseModel {
    constructor() {
        super({ 
                name: "obj_box",
                tableName: 'obj_box', 
                label: "Quản lý hộp",
                display_key: 'code',
            },  
            {
                stt: { 
                    name: "stt",
                    label: "STT",
                    width : 5,
                    class: 'center',
                    computed: (data, index) => {
                        data.stt = index + 1;
                    }
                },
                id: { 
                    name: 'id', 
                    type: "Uuid", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                code: {
                    name: 'code', 
                    type: "String", 
                    label: 'Mã hộp'
                },
                unit_id: {
                    name: 'unit_id', 
                    type: "Uuid", 
                    label: 'ID đơn vị',
                    display: false
                },
            },
        )
    }

}